export const ERROR_NO_WEB3 = 'No web3 defined in store';
export const UNSUPPORTED_NETWORK = 'Network not supported';
export const CANT_LOAD_CONTRACT = "Can't load stored contract nor create contract";
export const MULTISIG_DOES_NOT_EXIST = 'Multisignature wallet does not exist';
